import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import * as actions from '../../../../actions/productData';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag
} from '../../../../Flags/selectors';
import PriceRevealPLP from '../../../common/ListingPage/priceRevealPLP/PriceRevealPLP';
import { getIsPriceRevealPDP, getShowPriceRevealOnSimilar } from '../../../../utils/pdp';
import { addCustomerType } from '../../../../utils/products';
import {
  luxeGtmProductClick,
  luxeGtmProductImpressions,
  getStoreName,
  segmentEventPush
} from '../../../../modules/ga/GTMdatalayer';
import { redirect } from '../../../../refresh/utils/cartUtils';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { displayValueWithSymbol } from '../../../../utils/price';
import {
  getTagValueFromTagEngine,
  getPriceLableFromTagEngine,
  getSimilarProductsWithLimit
} from '../../../../utils/product';
import luxeList from '../../../../refresh/constants/luxeScreenType';
import { getVariant } from '../../../../refresh/organism/ABFeature/Feature';
import { isCatalogNameInFirebaseStore } from '../../../../utils/common';
import {
  getStoresForHidingMRP,
  getSimilarProductsMaxLimit,
  getGiftWithProductEnable,
  getGiftWithProductConfig
} from '../../../../refresh/selectors/featureFlagsSelector';
import { readCookie } from '../../../common/Cookie';
import { catalogIdToStoreName } from '../../../../utils';
import { replaceWithJioCDN } from '../../../../../src/utils/imageHandling';

class SimilarStyles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialIndex: 4,
      previousIndex: 0,
      hasObserverBlockCall: false
    };
    this.similarStyleBlockRef = React.createRef();
  }

  openModal(prodData, e) {
    if (e) e.preventDefault();
    this.props.openModal(prodData);
  }

  componentDidUpdate(prevProps, prevState) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.state.hasObserverBlockCall) {
          this.setState({ hasObserverBlockCall: !this.state.hasObserverBlockCall });
          this.handleObserver();
          segmentEventPush({
            event:'Widget Viewed', 
            screen_name: '',            
            widget_id: 'similar_styles',
            widget_name: 'Similar Styles',
            widget_position: '',
            widget_type: 'Similar Styles Widget'
          });
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    if (this.similarStyleBlockRef.current) observer.observe(this.similarStyleBlockRef.current);
  }

  handleObserver = () => {
    const { product: { similarProducts = [] } = {}, parentProduct } = this.props;
    if (similarProducts && similarProducts.length)
      this.productImpressionsEventPush(parentProduct, similarProducts.slice(0, 4));
  };

  productImpressionsEventPush = (parentProduct, product) => {
    const { newDesignLuxe, isNewProductTag, currentStore, enableGiftWithProduct } = this.props;
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    let impressions = product.map((data, index) => {
      const {
        name: description,
        brand,
        code = '',
        price: { value: priceValue = '' },
        fnlColorVariantData: {
          colorGroup: productColor = '',
          exclusiveTill: isExclusive = '',
          productTag = ''
        } = {},
        brickCategory: productCategory = '',
        brickName,
        discount = '',
        catalogName = '',
        tags: { categoryTags = [] } = {},
        segmentId = '',
        experimentId = '',
        offerPrice = {}
      } = data;

      const { giftAvailable = false } = offerPrice;
      const productId = code && code.length > 9 ? code.substring(0, 9) : code;
      const tag = isExclusive ? 'Exclusive' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const dimension60Data =
        Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';
      return {
        name: description,
        id: productId,
        price: priceValue,
        brand,
        category: productCategory,
        list: 'pdp screen - similar product widget', // example only,
        position: index,
        dimension6: description, // pass value for product_name
        dimension7: productId, // pass value for product_id
        dimension8: brand, // pass value for product_brand
        dimension9: priceValue, // pass value for product_price
        dimension10: productColor, // pass value for product_color
        dimension11: '', // pass value for product_size
        dimension12: '', // pass value for product_trade_discount
        dimension13: productCategory, // pass value for product_category
        dimension14: brickName, // pass value for product_brick
        dimension15: tag, // pass value for product_tag
        dimension16: currentStore, // pass value for Store_type
        dimension23: catalogIdToStoreName(catalogName),
        dimension16: 'AJIO', // pass value for Store_type
        dimension60: dimension60Data,
        dimension89: getVariant('enable_urgency_driver_pdp') ? productTagEngineValue : '',
        dimension90: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
        dimension91: '',
        dimension82: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
      };
    });
    luxeGtmProductImpressions({
      impressions,
      list: 'pdp screen',
      store_type: 'AJIO',
      page_name: screenName,
      page_type: screenType,
      contains_luxe: true,
      ProductArray: impressions,
      parentProduct : parentProduct,
    });
  };

  onNextClick = index => {
    const { product: { similarProducts = [] } = {}, parentProduct } = this.props;
    const { initialIndex, previousIndex } = this.state;
    if (index + 1 > initialIndex) {
      this.setState({ initialIndex: initialIndex + 4, previousIndex: previousIndex + 4 });
      this.productImpressionsEventPush(parentProduct, similarProducts.slice(previousIndex + 4, initialIndex + 4));
    }
  };

  render() {
    const {
      product = {},
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData = {},
      store = '',
      priceRevealLUXEFlag = false,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      isNewProductTag,
      storesForHidingMRP,
      similarProductsMaxLimit = 0,
      enableGiftWithProduct,
      giftWithProductConfig,
      parentProduct = {},
    } = this.props;
    const data = Object.keys(product).length === 0 ? '' : product;
    if (Object.keys(data).length === 0) {
      return null;
    }
    let similarStyleData = getSimilarProductsWithLimit(
      product.similarProducts,
      similarProductsMaxLimit
    );
    const { priceRevealMetaInfo = {} } = product || {};
    const { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};
    const isPriceRevealPDP = getShowPriceRevealOnSimilar(saleStartTime, saleEndTime);
    const isPriceReveal = getIsPriceRevealPDP(
      priceRevealV2WebFeatureFlag,
      priceRevealV2WebData,
      priceRevealMetaInfo,
      store,
      priceRevealLUXEFlag
    );
    if (!similarStyleData || similarStyleData.length === 0) {
      return null;
    }
    return (     
      <div className="comp-section similar-styles" ref={this.similarStyleBlockRef} onClick={e=>{
          segmentEventPush({
            event:'Widget Clicked', 
            screen_name: '',            
            widget_id: 'similar_styles',
            widget_name: 'Similar Styles',
            widget_position: '',
            widget_type: 'Similar Styles Widget'
          });
      }}
      role="group"
      aria-labelledby='similar-styles-header'
      >
        <h3 className="align-center" role="heading" aria-level="2">
          <span id="similar-styles-header">Similar Styles</span>
        </h3>
        <DataList
          storesForHidingMRP={storesForHidingMRP}
          data={similarStyleData}
          openModal={this.openModal.bind(this)}
          isPriceReveal={isPriceReveal}
          isPriceRevealPDP={isPriceRevealPDP}
          luxeEventPush={luxeEventPush}
          newDesignLuxe={newDesignLuxe}
          currentStore={currentStore}
          onNextClick={this.onNextClick}
          isNewProductTag={isNewProductTag}
          enableGiftWithProduct={enableGiftWithProduct}
          giftWithProductConfig={giftWithProductConfig}
        />
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div
      className={className}
      style={{ display: arrow, textAlign: 'center', zIndex: 1 }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  let arrow = 'block';
  if (props.slideCount <= 4) {
    arrow = 'none';
  }
  return (
    <div
      className={className}
      style={{ display: arrow, textAlign: 'center', zIndex: 1 }}
      onClick={onClick}
    />
  );
}

class DataList extends React.Component {
  render() {
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const {
      pdpList: { similarList = '', youMayAlsoLikeList = '' }
    } = luxeList;

    let similarStyleImg = '';
    const {
      isPriceReveal,
      isPriceRevealPDP,
      newDesignLuxe,
      luxeEventPush,
      currentStore,
      onNextClick,
      isNewProductTag,
      storesForHidingMRP,
      enableGiftWithProduct,
      giftWithProductConfig
    } = this.props;
    let slickSettings = {
      dots: false,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      swipe: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      lazyLoad: true,
      lazyLoadOffset: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      afterChange: onNextClick
    };

    if (!this.props.data) {
      return null;
    }

    var dataListItems = this.props.data.map((data, index) => {
      let image;
      const { offerPrice = {}, catalogName } = data;
      const { priceReveal = {}, value: offerValue = '', giftAvailable = false } = offerPrice;
      data.images.map((img, i) => {
        if (img.format === 'productGrid3ListingImage') {
          image = img.url;
        }
      });
      const {
        colorGroup,
        exclusiveTill = '',
        productTag = '',
        brandName = ''
      } = data.fnlColorVariantData;
      const { tags: { categoryTags = [] } = {}, name = '' } = data;
      const productTagValue = exclusiveTill ? 'EXCLUSIVE' : productTag;
      const productTagEngineValue = getTagValueFromTagEngine(categoryTags);
      const productPriceLabel = getPriceLableFromTagEngine(categoryTags);
      const redirectFn = redirect(data.url);
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);
      
      return (
        <Col key={index}>
          <a
            tabIndex={0}
            //  href={addCustomerType(data.url)}
            className="prod-sec"
            target="_self"
            rel=""
            onClick={e => {
              e.preventDefault();
              redirectFn();
              luxeEventPush({
                eventName: 'widget_clicks',
                event_category: 'widget interactions',
                event_action: 'widget clicks',
                event_label: 'similar to widget',
                product_name: data.name,
                product_id:
                  data.code && data.code.length > 9 ? data.code.substring(0, 9) : data.code,
                product_brand: data.fnlColorVariantData.brandName,
                product_price: data.wasPriceData.displayformattedValue,
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_size: '',
                product_trade_discount: data.discountPercent,
                product_catogory: data.brickCategory,
                product_brick: data.brickName,
                product_tag: isNewProductTag ? productTagEngineValue : productTagValue
              });
              luxeGtmProductClick({
                name: data.name,
                id: data.code && data.code.length > 9 ? data.code.substring(0, 9) : data.code,
                price: data.wasPriceData.displayformattedValue,
                brand: data.fnlColorVariantData.brandName,
                position: index,
                category: data.brickCategory,
                product_size: '',
                product_color: data.fnlColorVariantData.colorGroup
                  ? data.fnlColorVariantData.colorGroup.split('_')[1]
                  : '',
                product_trade_discount: data.discountPercent,
                product_brick: data.brickName,
                product_tag: productTagValue,
                list: similarList,
                store_type: currentStore,
                pageType: screenType,
                pageName: screenName,
                sourceStore: currentStore,
                containsLuxe: true,
                productPriceLabel: getVariant('enable_urgency_driver_pdp') ? productPriceLabel : '',
                productTagEngineValue: getVariant('enable_urgency_driver_pdp')
                  ? productTagEngineValue
                  : '',
                catalog: catalogName,
                segmentId: data.segmentId,
                experimentId: data.experimentId,
                offerName: enableGiftWithProduct && giftAvailable ? 'GetFreebies' : ''
              });
              window.location.href = addCustomerType(data.url);
            }}
            aria-label={`Product image of ${data?.fnlColorVariantData.brandName}, ${data?.name}, MRP ${displayValueWithSymbol(data?.price?.displayformattedValue)}${data?.wasPriceData?.value > data?.price?.value && hideMRP ? `; ${displayValueWithSymbol(data?.wasPriceData?.displayformattedValue)} strike off; available at ${data?.discountPercent}` : ''}`}
          >
            <div className="sec-prod-disp" aria-hidden="true" tabIndex={-1}>
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              <img
                className="sec-img"
                src={`${replaceWithJioCDN(image)}`}
                width="204px"
                height="256px"
                alt=""
              />

              {isNewProductTag && productTagEngineValue ? (
                <div
                  className={
                    newDesignLuxe ? 'luxe-sec-prod-exclusive-new' : 'sec-prod-exclusive-new'
                  }
                >
                  {productTagEngineValue}
                </div>
              ) : productTagValue ? (
                <div className="sec-prod-exclusive" aria-label={productTagValue}>{productTagValue}</div>
              ) : (
                ''
              )}
              {data.fnlColorVariantData.allPromotions ? <div className="sec-prod-offer" /> : ''}

              <div
                id="quickview"
                role="button"
                tabIndex={0}
                className="prod-quickview"
                onClick={e => {
                  e.stopPropagation();
                  this.props.openModal(colorGroup);
                }}
              >
                <span>QUICK VIEW</span>
              </div>
            </div>

            <div className="sec-product-details" aria-hidden="true" tabIndex={-1}>
              <div role='heading' aria-level={3}>
              <div className="sec-prod-title" aria-label={data.fnlColorVariantData.brandName}>{data.fnlColorVariantData.brandName}</div>
              <div className="sec-prod-subtitle" aria-label={data.name}>{data.name}</div>
              </div>
              {data.price && data.price.displayformattedValue ? (
                <div className="sec-prod-cp">
                  {displayValueWithSymbol(data.price.displayformattedValue)}
                </div>
              ) : (
                ''
              )}

              {data.wasPriceData &&
              data.wasPriceData.value &&
              data.wasPriceData.value > data.price.value &&
              hideMRP ? (
                <div className="sec-prod-price">
                  <span className="sec-prod-sp">
                    <span>{displayValueWithSymbol(data.wasPriceData.displayformattedValue)}</span>
                  </span>
                  &nbsp;
                  <span className="discount-percent">&nbsp;({data?.discountPercent})</span>
                </div>
              ) : (
                ''
              )}
              {/* Add GWP Here for product widget for Desktop */}
              {enableGiftWithProduct && giftAvailable &&
                <div className='gwp-container'>
                  <span className={newDesignLuxe ? 'gwp-text-luxe' : 'gwp-text'}>{giftWithProductConfig.productWidgetTitle}</span>
                </div>
              }
              {isPriceReveal && (
                <PriceRevealPLP
                  priceRevealClass="pr-pdp-desktop"
                  isPriceRevealPDP={isPriceRevealPDP}
                  priceReveal={priceReveal}
                  orignalPrice={data.price.value}
                  offerValue={data?.offerPrice?.value}
                  deviceType="desktop"
                  pageType="pdp"
                  luxe={newDesignLuxe}
                  hasLineBreak={!!newDesignLuxe}
                />
              )}
            </div>
          </a>
        </Col>
      );
    });

    if (this.props.data.length > 4) {
      return (
        <Slider {...slickSettings} ref="slick">
          {dataListItems}
        </Slider>
      );
    }

    return <Row>{dataListItems}</Row>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {}, metaData = {} } = state;
  const { sis, name } = metaData;
  const storeName = getCurrentStore(state);
  return {
    product: state.product.similarData,
    priceRevealV2WebFeatureFlag: getPriceRevealV2WebFeatureFlag(flags),
    priceRevealV2WebData: getPriceRevealWebData(flags),
    priceRevealLUXEFlag: getPriceRevealLUXEFlag(flags),
    store: sis ? name : 'AJIO',
    currentStore: storeName,
    storesForHidingMRP: getStoresForHidingMRP(state),
    similarProductsMaxLimit: getSimilarProductsMaxLimit(state),
    enableGiftWithProduct: getGiftWithProductEnable(flags),
    giftWithProductConfig: getGiftWithProductConfig(state),
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  let productId = ownProps.productCode;
  const showSimilarItems = ownProps.showSimilarItems;
  return {
    fetchData: setTimeout(function() {
      showSimilarItems && dispatch(actions.getSimilarStyles(productId));
    }, 500),
    openModal: productId => dispatch(actions.openModal(productId))
  };
};

export default SimilarStyles = connect(mapStateToProps, mapDispatchToProps)(SimilarStyles);
